import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux';
import no_photo from './GRAPHIC_no_photo.png';
import logo from './GRAPHIC_Fix-a-Drink_logo.png';
import createAccount from './ICON_NavigationBar_save.png';
import login_img from './GRAPHIC_login.png';
import './NavigationBar.css';

class NavigationBar extends Component {
  // https://pixabay.com/en/cocktail-coconut-drink-flower-food-159586/
  render() {
    const user = this.props.authentication.user;

    return (
      <div className="App">
        <header className="App-header">
          <div className="register-login-outer-div" style={{textAlign: 'right',height: '80px', position:'absolute', top: '33px'}}>
            {user && user.first_name != "Guest" &&
            <Link to="/edit_profile">
              <div className="profile-header-img">
                <img class="img-circle" src={user.img_url ? 'data:image/png;base64,' + user.img_url : no_photo} />
                <div className="rank-label-container">
                  <span className="label label-default rank-label">{user.first_name}</span>
                </div>
              </div>
            </Link>
            }


            {user && user.first_name == "Guest" && !window.location.href.includes('login') &&
            <Link to="/login">
              <div className="profile-header-img profile-header-guest">
                <img class="img-circle" src={login_img}/>

                <div className="rank-label-container">
                  <span className="label label-default rank-label">Login</span>
                </div>
              </div>
            </Link>
            }
            {user && user.first_name == "Guest" && !window.location.href.includes('register') &&
            <Link to="/register">
              <div className="profile-header-img profile-header-guest profile-header-create-account">
                <img class="img-circle" src={createAccount}/>

                <div className="rank-label-container">
                  <span className="label label-default rank-label">Create an Account</span>
                </div>
              </div>
            </Link>
            }

          </div>
          <img src={logo} style={{width:'90px'}} className="App-logo" alt="logo"/>
          <h1 className="App-title">Fix-A-Drink</h1>
          <nav>
            <ul className="tabrow">
              <NavLink activeClassName="selected" exact={true} to="/"><li>Home</li></NavLink>
              <NavLink activeClassName="selected" to="/party_time">
                <li>Party Time</li>
              </NavLink>
              {user && user.access_level >= 4 &&
              <NavLink activeClassName="selected" to="/recipe">
                <li>Recipes</li>
              </NavLink>
              }
              {user && user.access_level >= 4 &&
              <NavLink activeClassName="selected" to="/ingredient">
                <li>Ingredients</li>
              </NavLink>
              }
              <NavLink activeClassName="selected" to="/about"><li>About</li></NavLink>
              <NavLink activeClassName="selected" to="/contact"><li>Contact</li></NavLink>
              {user && user.access_level >= 8 &&
              <NavLink activeClassName="selected" to="/admin"><li>Admin</li></NavLink>
              }
            </ul>
          </nav>

        </header>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication
  };
}

const connectedNavigationBar = connect(mapStateToProps, null, null, {pure:false})(NavigationBar);
export { connectedNavigationBar as NavigationBar };


// WEBPACK FOOTER //
// ./src/NavigationBar/NavigationBar.jsx